import CrudModule from "@/components/CrudModule";
import { Scroll } from "lucide-react";

export default function Legal() {
    return (
        <CrudModule
            testid="legal-page"
            eyebrow="Legal & Legacy"
            title="Wills, POAs, nominee maps."
            subtitle="So your wishes are clear and the paperwork is findable."
            endpoint="/legal"
            emptyIcon={Scroll}
            emptyTitle="No legal records yet"
            emptyBody="Track your Will, Power of Attorney, trusts, and nominee mappings — note where the originals live."
            fields={[
                { key: "legal_type", label: "Type", type: "select", required: true, defaultValue: "will",
                  options: [
                    { value: "will", label: "Will" },
                    { value: "poa", label: "Power of Attorney" },
                    { value: "trust", label: "Trust" },
                    { value: "nominee_map", label: "Nominee map" },
                    { value: "other", label: "Other" },
                  ] },
                { key: "title", label: "Title", required: true, placeholder: "Will — final 2024 / GPA for property" },
                { key: "executor", label: "Executor / Trustee", placeholder: "Spouse, brother, friend…" },
                { key: "location", label: "Original document location", placeholder: "Locker, lawyer's office…" },
                { key: "notes", label: "Notes", type: "textarea" },
            ]}
            columns={[
                { key: "legal_type", label: "Type",
                  render: (r) => <span className="capitalize">{(r.legal_type || "").replace("_", " ")}</span> },
                { key: "title", label: "Title" },
                { key: "executor", label: "Executor" },
                { key: "location", label: "Location" },
            ]}
        />
    );
}
